import { addLoader, apiSlice, asyncToastDisplay, i18n } from "./apiSlice";
import qs from "qs"

const dashboardFilterUrl = (route, appId, filter) => {
  let url = `/apps/${appId}/${route}`
  if (filter) {
    const {startDate, endDate, ...rest} = filter
    url += `?${qs.stringify({date: {start_date: startDate, end_date: endDate}, ...rest}, { arrayFormat: 'brackets' })}`
  }
  return url
}

export const appApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getApp: builder.query({
      query: ({appId, filter}) => {
        return {
          url: dashboardFilterUrl("", appId, filter)
        }},
      providesTags: (result = [], error, arg) => [{ type: 'Apps', id: `kpis:${JSON.stringify(arg)}` } ],
      onQueryStarted: addLoader(),
    }),
    getAppDataByDay: builder.query({
      query: ({appId, filter}) => ({
        url: dashboardFilterUrl("data_by_day", appId, filter)
      }),
      providesTags: (result = [], error, arg) => [{ type: 'Apps', id: `data_by_day:${JSON.stringify(arg)}`  }],
    }),
    getAppConsents: builder.query({
      query: ({appId, filter}) => ({
        url: dashboardFilterUrl("consents", appId, filter)
      }),
      providesTags: (result = [], error, arg) => [{ type: 'Apps', id: `consents:${JSON.stringify(arg)}`  }],
    }),
    getAppVersions: builder.query({
      query: ({appId, filter}) => ({
        url: dashboardFilterUrl("versions", appId, filter)
      }),
      providesTags: (result = [], error, arg) => [{ type: 'Apps', id: `versions:${JSON.stringify(arg)}`  }],
    }),
    getAppSdkVersionPerDay: builder.query({
      query: ({appId, filter}) => ({
        url: dashboardFilterUrl("sdk_version_by_day", appId, filter)
      }),
      providesTags: (result = [], error, arg) => [{ type: 'Apps', id: `sdk_version_per_day:${JSON.stringify(arg)}`  }],
    }),
    getAppVersionPerDay: builder.query({
      query: ({appId, filter}) => ({
        url: dashboardFilterUrl("app_version_by_day", appId, filter)
      }),
      providesTags: (result = [], error, arg) => [{ type: 'Apps', id: `app_version_per_day:${JSON.stringify(arg)}`  }],
    }),
    getAppSdkVersion: builder.query({
      query: ({appId, filter}) => ({
        url: dashboardFilterUrl("sdk_version", appId, filter)
      }),
      providesTags: (result = [], error, arg) => [{ type: 'Apps', id: `sdk_version:${JSON.stringify(arg)}`  }],
    }),
    getAppAppVersion: builder.query({
      query: ({appId, filter}) => ({
        url: dashboardFilterUrl("app_version", appId, filter)
      }),
      providesTags: (result = [], error, arg) => [{ type: 'Apps', id: `app_version:${JSON.stringify(arg)}`  }],
    }),
    getApps: builder.query({
      query: () => {
        return {
          url: '/apps'
        }},
      providesTags: (result = [], error, arg) => [{ type: 'Apps', id: 'LIST' } ]
    }),
  }),
  overrideExisting: false
})

export const {
  useGetAppQuery,
  useGetAppDataByDayQuery,
  useGetAppConsentsQuery,
  useGetAppVersionsQuery,
  useGetAppSdkVersionPerDayQuery,
  useGetAppVersionPerDayQuery,
  useGetAppSdkVersionQuery,
  useGetAppAppVersionQuery,
  useGetAppsQuery
} = appApiSlice
